export const canManageAffiliates = user => {
    const profile = user?.data || {}
    const role = String(profile.role || "").toLowerCase()
    return role === "admin" ? true : false
}
